/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage,SuccessPage,DeclarationPage, RiskAnalysisPage } from 'premier-capability-policyjob-react';
import InfoPage from './pages/Info/InfoPage';
import QuestionsPage from './pages/Questions/QuestionsPage';
import ExposuresPage from './pages/Exposures/ExposuresPage';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import DriversPage from './pages/Drivers/DriversPage';
import VehiclesPage from './pages/Vehicles/VehiclesPage';
import CoverablesPage from './pages/Coverables/CoverablesPage';
import SingleCoverablePage from './pages/Coverables/SingleCoverablePage';
import QuotePage from './pages/Quote/QuotePage';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';

setComponentMapOverrides(
    {
        // wizard pages
        PremierRVPolicyDetailsPage: { component: 'PremierRVPolicyDetailsPage' },
        PremierRVDeclarationPage: { component: 'PremierRVDeclarationPage' },
        PremierOfferingsPage : { component: 'PremierOfferingsPage'},
        PremierRVLocationsPage : { component: 'PremierRVLocationsPage'},
        PremierRVDriversPage : { component: 'PremierRVDriversPage'},
        PremierRVVehiclesPage : { component: 'PremierRVVehiclesPage'},
        PremierRVRiskAnalysisPage : { component: 'PremierRVRiskAnalysisPage'},
        PremierRVInfoPage: { component: 'PremierRVInfoPage' },
        PremierRVQuestionsPage: { component: 'PremierRVQuestionsPage' },
        PremierRVSingleCoverablePage: { component: 'PremierRVSingleCoverablePage' },
        PremierRVExposuresPage: { component: 'PremierRVExposuresPage' },
        PremierRVCoveragesPage: { component: 'PremierRVCoveragesPage' },
        PremierRVCoverablesPage: { component: 'PremierRVCoverablesPage' },
        PremierRVQuotePage: { component: 'PremierRVQuotePage' },
        PremierRVPolicyInfoPage: { component: 'PremierRVPolicyInfoPage' },
        PremierRVPaymentDetailsPage: { component: 'PremierRVPaymentDetailsPage' },
        PremierRVSuccessPage: { component: 'PremierRVSuccessPage' } 
    },
    {
        // wizard pages
        PremierRVPolicyDetailsPage: PolicyDetailsPage,
        PremierRVDeclarationPage: DeclarationPage,
        PremierOfferingsPage: OfferingsPage,
        PremierRVLocationsPage: LocationsPage,
        PremierRVDriversPage: DriversPage,
        PremierRVVehiclesPage: VehiclesPage,
        PremierRVRiskAnalysisPage: RiskAnalysisPage,
        PremierRVInfoPage: InfoPage,
        PremierRVQuestionsPage: QuestionsPage,
        PremierRVSingleCoverablePage: SingleCoverablePage,
        PremierRVExposuresPage: ExposuresPage,
        PremierRVCoveragesPage: CoveragesPage,
        PremierRVCoverablesPage: CoverablesPage,
        PremierRVQuotePage: QuotePage,
        PremierRVPolicyInfoPage: PolicyInfoPage,
        PremierRVPaymentDetailsPage: PaymentDetailsPage,
        PremierRVSuccessPage: SuccessPage
    }
);
export { CodegenWizard, CodegenContext };
